import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  TemplateRef,
  ViewChild,
  EventEmitter,
  Output,
} from '@angular/core';
import { IDropdownPanel } from './dropdown-panel/dropdown-panel.interface';

@Component({
  selector: 'app-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuComponent implements OnInit, IDropdownPanel {
  @ViewChild(TemplateRef) templateRef!: TemplateRef<any>;

  @Input() text: string = 'Меню';

  @Output() closed = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  onClick(event: Event) {
    event.stopPropagation();
  }
}
